import CustomImageComponent from '@/components/shared/custom/custom-image';
import CustomLink from '@/components/shared/custom/custom-link';
import { Rutas } from '@/constants/rutas';

export const LOGO_VARIANTS = {
    SOLO_LETRAS_BLANCO: 'SOLO_LETRAS_BLANCO',
    FONDO_OSCURO_LETRAS_VERDES: 'FONDO_OSCURO_LETRAS_VERDES',
    FONDO_VERDE_LETRAS_BLANCAS: 'FONDO_VERDE_LETRAS_BLANCAS',
    FONDO_VERDE_LETRAS_OSCURAS_BORDER: 'FONDO_VERDE_LETRAS_OSCURAS_BORDER',
    FONDO_VERDE_LETRAS_OSCURAS_CIRCLE: 'FONDO_VERDE_LETRAS_OSCURAS_CIRCLE',
    FONDO_VERDE_LETRAS_OSCURAS: 'FONDO_VERDE_LETRAS_OSCURAS',
    SOLO_LETRAS_NEGRAS: 'SOLO_LETRAS_NEGRAS',
    TEXTO_Y_LETRAS_VERDES: 'TEXTO_Y_LETRAS_VERDES',
    LETRAS_VERDES_TEXTO_OSCURO: 'LETRAS_VERDES_TEXTO_OSCURO',
    SOLO_LETRAS_NEGRAS: 'SOLO_LETRAS_NEGRAS',
    SOLO_LETRAS_VERDES: 'SOLO_LETRAS_VERDES',
};

const LOGO_CONFIG = {
    [LOGO_VARIANTS.SOLO_LETRAS_BLANCO]: {
        imageName: 'blanco-letras.png',
        coef: 1.8085,
    },
    [LOGO_VARIANTS.FONDO_OSCURO_LETRAS_VERDES]: {
        imageName: 'fondo-oscuro_letras-verdes.png',
        coef: 1,
    },
    [LOGO_VARIANTS.FONDO_VERDE_LETRAS_BLANCAS]: {
        imageName: 'fondo-verde_letras-blancas.png',
        coef: 1,
    },
    [LOGO_VARIANTS.FONDO_VERDE_LETRAS_OSCURAS_BORDER]: {
        imageName: 'fondo-verde_letras-oscuras_border.png',
        coef: 1,
    },
    [LOGO_VARIANTS.FONDO_VERDE_LETRAS_OSCURAS_CIRCLE]: {
        imageName: 'fondo-verde_letras-oscuras_circle.png',
        coef: 1,
    },
    [LOGO_VARIANTS.FONDO_VERDE_LETRAS_OSCURAS]: {
        imageName: 'fondo-verde_letras-oscuras.png',
        coef: 1,
    },
    [LOGO_VARIANTS.SOLO_LETRAS_NEGRAS]: {
        imageName: 'letras-texto-negro.png',
        coef: 5.27,
    },
    [LOGO_VARIANTS.TEXTO_Y_LETRAS_VERDES]: {
        imageName: 'letras-texto-verde.png',
        coef: 5.27,
    },
    [LOGO_VARIANTS.LETRAS_VERDES_TEXTO_OSCURO]: {
        imageName: 'etras-verde_texto-negro.png',
        coef: 5.27,
    },
    [LOGO_VARIANTS.SOLO_LETRAS_VERDES]: {
        imageName: 'negro-letras.png',
        coef: 1.81,
    },
    [LOGO_VARIANTS.SOLO_LETRAS_VERDES]: {
        imageName: 'verde-letras.png',
        coef: 1.81,
    },
};

const AFLogo = ({
    width = 70,
    height = null,
    useLink = true,
    variant = LOGO_VARIANTS.SOLO_LETRAS_VERDES,
}) => {
    const config = LOGO_CONFIG[variant] || LOGO_CONFIG[LOGO_VARIANTS.SOLO_LETRAS_VERDES];

    const calculatedHeight = height ?? (width / config.coef).toFixed(0);
    const widthToUse = (width * 1.5).toFixed(0);
    const heightToUse = (calculatedHeight * 1.5).toFixed(0);

    const url = `${process.env.NEXT_PUBLIC_IMAGES}/marca/${config.imageName}?width=${widthToUse}&height=${heightToUse}`;

    const image = (
        <CustomImageComponent src={url} alt="logo-af" width={width} height={calculatedHeight} priority />
    );

    return useLink ? <CustomLink href={Rutas.INICIO}>{image}</CustomLink> : image;
};

export default AFLogo;
